import { createTheme, responsiveFontSizes } from '@mui/material/styles';

/**
 * Central colour palette and component customisations for the landing
 * page.  The colours have been chosen to meet WCAG AA contrast
 * requirements when used together.  You can adjust the hex values to
 * better match your brand while preserving legibility.
 */
const baseTheme = createTheme({
  palette: {
    // Deep navy primary colour with white contrast text
    primary: { main: '#1c3661', contrastText: '#ffffff' },
    // Gold secondary accent colour with dark text
    secondary: { main: '#e4b153', contrastText: '#1c3661' },
    // Light backgrounds for sections
    background: { default: '#f5f6fa', paper: '#ffffff' },
    // Neutral greys for subtle UI elements
    neutral: { main: '#f5f6fa', dark: '#d1d5db' },
    text: { primary: '#0e1a30' },
    greyPearl: {
      main: '#d1d5db',
      light: '#f5f6fa',
      dark: '#9ca3af',
      contrastText: '#0e1a30',
    },
  },
  typography: {
    fontFamily: ['Inter', 'Roboto', 'sans-serif'].join(','),
    h1: { fontWeight: 700 },
    h2: { fontWeight: 600, textTransform: 'uppercase' },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
  },
});

// Extend the base theme with component overrides.  These overrides
// ensure consistent border radii and provide a custom underline on
// section headings.  The AppBar inherits its backdrop styling via
// the component code, not here.
let theme = createTheme(baseTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 28,
          textTransform: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h2: {
          letterSpacing: '.5px',
          fontWeight: 700,
          position: 'relative',
          '::after': {
            content: '""',
            width: 48,
            height: 4,
            backgroundColor: baseTheme.palette.secondary.main,
            position: 'absolute',
            left: 0,
            bottom: -8,
            borderRadius: 2,
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          transition: 'color 0.2s',
          '&:hover .MuiListItemIcon-root': {
            color: baseTheme.palette.secondary.main,
          },
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;